<template>
  <Layout>
    <PageHeader
      :title="title"
      :items="items"
      :backButton="true"
      :prevRoutePath="backUrl"
    />

    <!-- Person details & top mention -->
    <div class="row">
      <div class="col-lg-4 col-sm-4">
        <div class="card h-100">
          <div class="card-body text-left">
            <div class="row">
              <div class="col-sm-12">
                <h5>{{ $t("twitter.basic-info") }} - {{ basicInfo.name }}
                  <a :href="'https://twitter.com/' + basicInfo.username" target="_blank"> @{{ basicInfo.username }}</a>
                </h5>
              </div>
            </div>
            <div class="mb-3 mt-4">
              <div class="media">
                <img
                  :src="
                    basicInfo.avatar != ''
                      ? basicInfo.avatar
                      : 'https://img.icons8.com/ios/240/000000/user-male-circle.png'
                  "
                  class="mr-3 rounded-circle avatar-md"
                  alt="user-pic"
                />
                <div class="media-body p-1 text-center">
                  <h6 class="mb-1">{{ $t("twitter.tweets") }}</h6>
                  <hr />
                  <h6>{{ basicInfo.tweets }}</h6>
                </div>
                <div class="media-body p-1 text-center">
                  <h6 class="mb-1">{{ $t("twitter.favorites") }}</h6>
                  <hr />
                  <h6>{{ basicInfo.favorites }}</h6>
                </div>
                <div class="media-body p-1 text-center">
                  <h6 class="mb-1">{{ $t("twitter.followers") }}</h6>
                  <hr />
                  <h6>{{ basicInfo.followers }}</h6>
                </div>
                <div class="media-body p-1 text-center">
                  <h6 class="mb-1">{{ $t("twitter.following") }}</h6>
                  <hr />
                  <h6>{{ basicInfo.following }}</h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-8 col-sm-8">
        <div class="card h-100">
          <div class="card-body text-left" style="margin-top: 5vh;">
            <form>
              <div class="row">
                <div class="col-sm-6"><h4>Select a date to view Engagement rate</h4></div>
                <div class="col-md-3 col-xs-12 px-1 pl-2">
                  <div class="form-group mt-1 mb-0">
                    <date-picker
                      v-model="daterange"
                      placeholder="Date Range"
                      class="text-center"
                      range
                      append-to-body
                      lang="en"
                      confirm
                    ></date-picker>
                  </div>
                </div>
                <div class="col-2 mb-1 px-1">
                  <div class="form-group mt-1 mb-0">
                    <b-form-select
                      v-model="periode"
                      :options="options"
                    ></b-form-select>
                  </div>
                </div>
                <div class="col-1 mb-1 px-1">
                  <div class="form-group mt-1 mb-0">
                    <b-button
                      variant="success"
                      @click="getData"
                      class="bx-2 btn btn-block"
                    >
                      <!-- <b-spinner
                        v-if="loading_filter"
                        label="Loading ..."
                        small
                      ></b-spinner>
                      <span v-if="!loading_filter"
                        ><i class="bx bx-filter"></i> Filter
                      </span>
                      <span v-if="loading_filter"> Loading.. </span> -->
                      <!-- made -->
                      <!-- <b-spinner
                        v-if="loading_filter"
                        label="Loading ..."
                        small
                      ></b-spinner> -->
                      <span><i class="bx bx-filter"></i> Filter
                      </span>
                      <!-- <span v-if="loading_filter"> Loading.. </span> -->
                    </b-button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-lg-12 col-sm-12">
        <!-- <div class="col-sm-12 p-5 mt-5 mb-5">
            <div class="text-center loading">
              <b-spinner label="Loading..."></b-spinner>
            </div>
          </div> -->
        <div class="card h-100" v-if="showEngagement">
          <div class="card-body text-left">
            <h5><b>Performance Summary</b></h5>
            <p>
              View your profile performance metrics from the reporting
              period.
            </p>

            <div class="row px-0 mx-0">
              <div class="col-6 border px-0">
                <div class="p-3">
                  <p>Total Engagement Berdasarakan Periode</p>
                  <h3>
                    {{ totalEn1 }}
                    <span v-if="totalRate >= 0" class="text-success text-grafik"
                      >
                      <i class="bx bx-trending-up"></i>
                      Naik {{ totalRate }}%
                    </span>
                    <span v-else class="text-danger text-grafik"
                      >
                      <i class="bx bx-trending-down"></i>
                      Turun {{ totalRate }}%
                    </span>
                    dari {{ totalEn2 }} <span style="font-size: 15px;">{{ periode }}</span>
                  </h3>
                </div>
              </div>
              <div class="col-6 border px-0">
                <div class="p-3">
                  <p>Rata - Rata Engagements Rate</p>
                  <h3>
                    {{ avgEngagement.toFixed(2) }} %
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-3" v-if="showChart">
      <div class="col-lg-12 col-sm-12">
        <div class="card h-100">
          <div class="card-body text-left">
            <h5><b>Engagement Growth</b></h5>

            <div class="row px-0 mx-0">
              <div class="col-12 border px-0">
                <div id="chart">
                  <apexchart
                    class="apex-charts"
                    height="340"
                    type="area"
                    dir="ltr"
                    :series="[{
                        name: 'Engagement',
                        data: nonzero
                      }]"
                    :options="{
                        chart: {
                          id: 'pageview-chart',
                          toolbar: {
                            show: false,
                          },
                        },
                        dataLabels: {
                          enabled: true,
                        },
                        colors: ['#6F5ED3'],
                        xaxis: {
                          categories: readableformat,
                        },
                    }"
                    ></apexchart>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import DatePicker from "vue2-datepicker";
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import TwintService from "@/helpers/twint.service";
import moment from "moment";
import SosmedService from "@/helpers/socmed.service";
import { gmapApi } from "vue2-google-maps";

import { ref } from "vue";

/**
 * Profile component
 */
export default {
  page: {
    title: "Twitter Report View",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, DatePicker },
  data() {
    return {
      backUrl: "/twitter",
      items: [
        {
          text: "Dashboard",
          href: "/",
        },
        {
          text: "Twitter",
          href: "/twitter",
        },
        {
          text: "Report View",
          active: true,
        },
      ],
      title: "Profile Performance",
      username: this.$route.params.id,
      dateFrom1: "",
      dateFrom2: "",
      dateTo1: "",
      dateTo2: "",
      theme: localStorage.getItem("theme"),
      daterange: null,
      periode: 'Compare With',
      options: ['Last 7 Days', 'Last Month', 'Last 3 Months','Compare With'],
      now_time: moment(),
      data1: null,
      data2: null,
      totalRate: 0,
      totalEn1: 0,
      totalEn2: 0,
      avgEngagement: 0,
      totalPerperiode: 0,
      datePerperiode: 0,
      startDate2: null,
      endDate2: null,
      loadingcart: false,
      readableformat: 0,
      nonzero: 0,
      showChart: false,
      showEngagement: false,
      id: this.$route.params.id,
      basicInfo: {
        id: "",
        name: "",
        username: "",
        bio: "",
        location: "",
        followers: "",
        following: "",
        tweets: "",
        likes: "",
        favorites: "",
        media: "",
        join_date: "",
        join_time: "",
        private: "",
        verified: "",
        avatar: "",
        updated_at: "",
      },
    };
  },
  computed: {},
  watch:{
    periode(newPeriode) {
      this.calculateDateRange(newPeriode);
    },
  },
  methods: {
    formatDate(date) {
      return new Date(date).toISOString();
    },
    calculateDateRange(periode) {
      const currentDate = new Date();
      if (periode === 'Last 7 Days') {
        this.startDate2 = new Date(currentDate);
        this.startDate2.setDate(currentDate.getDate() - 6);
      } else if (periode === 'Last Month') {
        this.startDate2 = new Date(currentDate);
        this.startDate2.setMonth(currentDate.getMonth() - 1);
      } else if (periode === 'Last 3 Months') {
        this.startDate2 = new Date(currentDate);
        this.startDate2.setMonth(currentDate.getMonth() - 3);
      }

      this.endDate2 = new Date(currentDate);

      this.startDate2 = this.formatDate(this.startDate2);
      this.endDate2 = this.formatDate(this.endDate2);
    },
    generateQuery(username, gte, lte) {
      return {
        size: 100,
        query: {
          bool: {
            must: [],
            filter: [
              {
                bool: {
                  should: [
                    {
                      match_phrase: {
                        "username.keyword": username,
                      },
                    },
                  ],
                  minimum_should_match: 1,
                },
              },
              {
                range: {
                  "timeline.date": {
                    format: "strict_date_optional_time",
                    gte: gte,
                    lte: lte,
                  },
                },
              },
            ],
            should: [],
            must_not: [],
          },
        },
      };
    },
    getUserBasicInfo() {
      SosmedService.detailTwitter(this.id)
        .then((response) => {
          this.basicInfo.id = response.data.data.user_id;
          this.basicInfo.name = response.data.data.name;
          this.basicInfo.username = response.data.data.account;
          this.basicInfo.bio = response.data.data.bio;
          this.basicInfo.location = response.data.data.location;
          this.basicInfo.followers = response.data.data.followers;
          this.basicInfo.following = response.data.data.following;
          this.basicInfo.tweets = response.data.data.tweets;
          this.basicInfo.likes = response.data.data.likes;
          this.basicInfo.favorites = response.data.data.favorites;
          this.basicInfo.media = response.data.data.media;
          this.basicInfo.join_date = response.data.data.join_at;
          this.basicInfo.private = response.data.data.is_private;
          this.basicInfo.verified = response.data.data.is_verified;
          this.basicInfo.avatar = response.data.data.avatar;
          this.basicInfo.updated_at = response.data.data.updated_at;
          console.log('basic Info ', this.basicInfo);
        })
        .catch((err) => {
          // console.log('basic err ->',err);
        });
    },
    getData() {
      let data1 = "";
      let data2 = "";

      if (this.daterange) {
        const startDate = this.daterange[0];
        const endDate = this.daterange[1];
        const startPeriodeDate2 = this.startDate2;
        const endPeriodeDate2 = this.endDate2;
        data1 = this.generateQuery(this.username, startDate, endDate);
        data2 = this.generateQuery(this.username, startPeriodeDate2, endPeriodeDate2);
        console.log('Start Date2:', this.startDate2);
        console.log('End Date2:', this.endDate2);
      } else {
        console.warn('Please select a date range.');
      }
      TwintService.GetEngagement(data1, data2)
        .then((response) => {
          let fnumber1 = response.data.totalEn1.toString();
          let fnumber2 = response.data.totalEn2.toString();
          this.totalRate = response.data.totalRate;
          this.totalEn1 = fnumber1.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
          this.totalEn2 = fnumber2.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
          this.avgEngagement = response.data.avgEngagement;
          this.totalPerperiode =  response.data.totalPeriode;
          this.datePerperiode =  response.data.datePeriode;
          this.nonzero = this.totalPerperiode.filter(function (nilai) {
              return nilai !== 0;
          });
          this.readableformat = this.datePerperiode.map(function (tanggalAwal) {
              var tanggal = new Date(tanggalAwal);
              var options = { month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric' };
              return tanggal.toLocaleDateString('id-ID', options);
          });
          // console.log(this.readableformat)
          // console.log(this.totalPerperiode)
          this.showChart = true;
          this.showEngagement = true;
        })
        .catch((err) => {
          this.loadingtimeline = false;
        });
    },
    getSupportRangedate() {
      if (this.daterange) {
        const startDate = this.daterange[0];
        const endDate = this.daterange[1];
        console.log('Start Date:', moment(startDate).toISOString());
        console.log('End Date:', moment(endDate).toISOString());
        console.log('Start Date2:', this.startDate2);
        console.log('End Date2:', this.endDate2);
      } else {
        console.warn('Please select a date range.');
      }
    }
  },
  mounted() {
    this.theme = localStorage.getItem("theme");
    this.getUserBasicInfo();
  },
};
</script>

<style scoped>
.text-grafik {
  font-size: 14px;
}
.my-custom-scrollbar {
  position: relative;
  height: 500px;
  overflow: auto;
}
.table-wrapper-scroll-y {
  display: block;
}
</style>
